// Generated by apps/web/scripts/generate-settings-search-index.mjs. Do not edit by hand.
// Regenerate (from apps/web): node scripts/generate-settings-search-index.mjs

import type { SettingsSearchIndex } from '@/lib/settings-search/types'

export const SETTINGS_SEARCH_INDEX: SettingsSearchIndex = {
  modules: {
    '/calendar': {
      '*': [
        {
          title: 'Calendar Settings',
          description:
            'Configure your calendar display, integrations, and sync behavior.',
        },
        {
          title: 'Display',
        },
        {
          title: 'Show tasks',
          description:
            'Display your tasks on the calendar based on their due dates.',
        },
        {
          title: 'Show external calendar events',
          description:
            'Display events from connected Google or Outlook calendars.',
        },
        {
          title: 'External calendars',
        },
        {
          title: 'Maintenance',
        },
        {
          title: 'Clear cache & resync',
        },
        {
          title: 'Reset filters',
          description: 'Reset all calendar filters to their default settings.',
        },
      ],
    },
    '/contacts': {
      categories: [
        {
          title: 'Categories',
          description: 'Create and manage categories to organize your contacts',
        },
      ],
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information about contacts',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      'data-quality': [
        {
          title: 'Data quality',
        },
        {
          title: 'No duplicates found',
          description: 'Every contact has a unique email and name.',
        },
        {
          title: 'Possible duplicate',
        },
        {
          title: 'Provider',
        },
        {
          title: 'API key',
        },
        {
          title: 'Base URL',
        },
        {
          title: 'Monthly limit',
        },
        {
          title: 'Enrichment active',
        },
        {
          title: 'Enrich contacts',
        },
        {
          title: 'Search contacts',
        },
        {
          title: 'Results',
          description: 'Results from the latest enrichment run.',
        },
      ],
      defaults: [
        {
          title: 'Default Settings',
          description: 'Configure default values for new contacts',
        },
        {
          title: 'Default Contact Type',
        },
        {
          title: 'Duplicate Check Field',
        },
        {
          title: 'Required Fields',
        },
        {
          title: 'Require Email',
          description: 'Require an email address when creating contacts',
        },
        {
          title: 'Require Phone',
          description: 'Require a phone number when creating contacts',
        },
        {
          title: 'Require Company',
          description: 'Require a company association when creating contacts',
        },
        {
          title: 'Automation',
        },
        {
          title: 'Duplicate Detection',
          description: 'Warn when creating contacts that may be duplicates',
        },
        {
          title: 'Activity Tracking',
          description: 'Track email opens, link clicks, and other activities',
        },
      ],
      'relationship-types': [
        {
          title: 'Lifecycle',
          description:
            'Configure contact lifecycle tracks and the stages used inside each track',
        },
        {
          title: 'Color',
        },
        {
          title: 'Lifecycle name',
        },
      ],
      scoring: [
        {
          title: 'Contact Scoring',
          description:
            'Set up rules to automatically score and prioritize contacts',
        },
        {
          title: 'Enable Contact Scoring',
        },
        {
          title: 'Score Thresholds',
        },
        {
          title: 'Hot Contact Threshold',
        },
        {
          title: 'Warm Contact Threshold',
        },
        {
          title: 'Scoring Rules',
        },
      ],
    },
    '/contracts': {
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information about contracts',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      defaults: [
        {
          title: 'Default Settings',
          description: 'Configure default values for new contracts',
        },
        {
          title: 'Default Contract Type',
        },
        {
          title: 'Default Duration',
        },
        {
          title: 'Duration Type',
        },
        {
          title: 'Workflow',
        },
        {
          title: 'Auto-renewal Default',
          description: 'Enable auto-renewal by default for new contracts',
        },
        {
          title: 'Require Approval',
          description:
            'When enabled, contracts must be approved before they can be marked as Signed or Active',
        },
        {
          title: 'Require Signature Details',
        },
        {
          title: 'Features',
        },
        {
          title: 'Enable Versioning',
          description: 'Track version history for contract changes',
        },
        {
          title: 'Enable Discussions',
          description: 'Allow team discussions on contracts',
        },
      ],
      'legal-statuses': [
        {
          title: 'Legal Statuses',
          description:
            'Configure legal status options available across your contracts',
        },
      ],
      personal: [
        {
          title: 'My Preferences',
          description: 'These settings only affect your account',
        },
        {
          title: 'Default Tab',
          description: 'Choose which tab opens by default when you view a .',
        },
        {
          title: 'Open records on',
        },
      ],
      reminders: [
        {
          title: 'Contract Reminders',
          description:
            'Configure reminder settings for contract renewals and expirations',
        },
        {
          title: 'Renewal Reminder (days before)',
        },
        {
          title: 'Expiry Reminder (days before)',
        },
      ],
      types: [
        {
          title: 'Contract Types',
          description:
            'Configure the contract types available across your organization',
        },
      ],
    },
    '/deals': {
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information about deals',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      defaults: [
        {
          title: 'Default Settings',
          description: 'Configure default values for new deals',
        },
        {
          title: 'Default Stage Type',
        },
        {
          title: 'Default Currency',
        },
        {
          title: 'Default Probability (%)',
        },
        {
          title: 'Rotten Deal Days',
        },
        {
          title: 'Require Deal Amount',
          description: 'Require a deal amount when creating new deals',
        },
        {
          title: 'Require Expected Close Date',
          description: 'Require an expected close date when creating new deals',
        },
        {
          title: 'Auto-create Activity',
          description:
            'Automatically create a follow-up activity when a deal is created',
        },
        {
          title: 'Enable Weighted Value',
          description:
            'Calculate weighted deal value based on stage probability',
        },
      ],
      personal: [
        {
          title: 'My Preferences',
          description: 'These settings only affect your account',
        },
        {
          title: 'Default Tab',
          description: 'Choose which tab opens by default when you view a .',
        },
        {
          title: 'Open records on',
        },
      ],
      pipeline: [
        {
          title: 'Pipeline Stages',
          description:
            'Configure the stages deals move through in your pipeline',
        },
        {
          title: "This pipeline isn't in canonical order",
        },
        {
          title: 'Win probability',
        },
      ],
      'roles-permissions': [
        {
          title: 'Roles & Permissions',
          description:
            'Customize deal record roles, fields, and sensitive financial capabilities',
        },
        {
          title: 'Default access',
        },
        {
          title: 'Admins inherit',
        },
        {
          title: 'Members inherit',
        },
        {
          title: 'No roles loaded yet',
          description: 'Refresh to seed the defaults, or create a custom role.',
        },
        {
          title: 'Role name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Allowed keys',
        },
        {
          title: 'Denied keys',
        },
      ],
      scoring: [
        {
          title: 'Deal Scoring',
          description:
            'Set up rules to score forecast quality and deal readiness',
        },
        {
          title: 'Enable Deal Scoring',
        },
        {
          title: 'Score Thresholds',
        },
        {
          title: 'Strong Deal Threshold',
        },
        {
          title: 'Watch Deal Threshold',
        },
        {
          title: 'Forecast Win-Rate',
        },
        {
          title: 'Headline forecast driver',
        },
        {
          title: 'Cold-start sample floor',
        },
      ],
    },
    '/entities': {
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information about',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      defaults: [
        {
          title: 'Default Settings',
          description: 'Configure default values for new',
        },
        {
          title: 'Default Values',
          description:
            'Initial values applied to newly created and how duplicates are detected.',
        },
        {
          title: 'Duplicate Check Field',
        },
        {
          title: 'Required Fields',
          description: 'Fields members must fill in when creating .',
        },
        {
          title: 'Require Website',
        },
        {
          title: 'Automation',
          description: 'Behaviors applied automatically when working with .',
        },
        {
          title: 'Duplicate Detection',
        },
        {
          title: 'Enable Relationships',
        },
        {
          title: 'Activity Tracking',
        },
      ],
      lifecycle: [
        {
          title: 'Lifecycle Stages',
          description:
            'Configure the lifecycle stages used for saved views, detail headers, and access gates',
        },
        {
          title: "This pipeline isn't in canonical order",
        },
        {
          title: 'Win probability',
        },
      ],
      personal: [
        {
          title: 'My Preferences',
          description: 'These settings only affect your account',
        },
        {
          title: 'Default Tab',
          description: 'Choose which tab opens by default when you view a .',
        },
        {
          title: 'Open records on',
        },
      ],
      'portal-branding': [
        {
          title: 'Portal Branding',
          description:
            'Logo, colors, and cover image for the client-facing portal',
        },
        {
          title: 'Logo',
        },
        {
          title: 'Portal logo',
          description:
            'Shown in the portal sidebar. Different from your operator-app logo.',
        },
        {
          title: "Use my organization's logo",
          description: 'Keep the portal in sync with your organization logo.',
        },
        {
          title: 'Colors',
        },
        {
          title: 'Primary accent',
        },
        {
          title: 'Presets',
        },
        {
          title: 'Secondary accent',
        },
        {
          title: 'Sidebar',
        },
        {
          title: 'Cover Image',
          description:
            "Shown at the top of every client's home page. Skip for a clean greeting band.",
        },
        {
          title: 'Preview',
          description:
            'A quick look at how branding appears in the client portal.',
        },
      ],
      'portal-permission-templates': [
        {
          title: 'Permission Templates',
          description:
            'Reusable bundles of client-portal permissions you can apply to clients',
        },
        {
          title: 'Templates',
          description:
            'Apply a template to a client from its portal Setup page to set the permission baseline.',
        },
        {
          title: 'No templates yet',
          description:
            'Create a template to quickly apply a consistent set of portal permissions across clients.',
        },
        {
          title: 'Name',
        },
        {
          title: 'Description',
        },
      ],
      'roles-permissions': [
        {
          title: 'Roles & Permissions',
          description:
            'Customize record roles, fields, and sensitive capabilities',
        },
        {
          title: 'Default access',
        },
        {
          title: 'Admins inherit',
        },
        {
          title: 'Members inherit',
        },
        {
          title: 'No roles loaded yet',
          description: 'Refresh to seed the defaults, or create a custom role.',
        },
        {
          title: 'Role name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Allowed keys',
        },
        {
          title: 'Denied keys',
        },
      ],
      scoring: [
        {
          title: 'Client Health Scoring',
          description: 'Set up rules to calculate and prioritize client health',
        },
        {
          title: 'Enable Client Health Scoring',
        },
        {
          title: 'Status thresholds',
        },
        {
          title: 'Healthy Threshold',
        },
        {
          title: 'Watch Threshold',
        },
        {
          title: 'Axis weights',
        },
        {
          title: 'relationship',
          description: 'Relationship',
        },
        {
          title: 'delivery',
          description: 'Delivery',
        },
        {
          title: 'commercial',
          description: 'Commercial',
        },
        {
          title: 'Signal penalties',
          description:
            'Points deducted from an axis score for each open delivery or commercial issue.',
        },
        {
          title: 'Commercial targets',
        },
        {
          title: 'Target margin (%)',
        },
        {
          title: 'Target collection ratio (%)',
        },
        {
          title: 'Scope-creep penalty cap (pts)',
        },
        {
          title: 'Full-penalty at creep (%)',
        },
        {
          title: 'Recency window (days)',
        },
        {
          title: 'Triage & alerts',
        },
        {
          title: 'criticalValueAtRisk',
          description: 'Critical value at risk ($)',
        },
        {
          title: 'highValueAtRisk',
          description: 'High value at risk ($)',
        },
        {
          title: 'mediumValueAtRisk',
          description: 'Medium value at risk ($)',
        },
        {
          title: 'Alert value at risk ($)',
        },
        {
          title: 'Alert relationship score gate',
        },
        {
          title: 'Advanced',
        },
      ],
    },
    '/events': {
      'agenda-types': [
        {
          title: 'Agenda Types',
          description: 'Configure types for agenda blocks and schedule items',
        },
      ],
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information about events',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      defaults: [
        {
          title: 'Default Settings',
          description: 'Configure default values for new events',
        },
        {
          title: 'Default Values',
          description:
            'Initial duration and event type applied to newly created events.',
        },
        {
          title: 'Default Duration (minutes)',
        },
        {
          title: 'Default Event Type',
        },
        {
          title: 'Working Hours',
          description: 'The default schedule used when planning new events.',
        },
        {
          title: 'Working Hours Start',
        },
        {
          title: 'Working Hours End',
        },
        {
          title: 'Event Behavior',
          description:
            'Toggle features for new events and how they appear in your calendar.',
        },
        {
          title: 'Enable Recurring Events',
          description: 'Allow events to be set as recurring',
        },
        {
          title: 'Show Declined Events',
          description: 'Display events you have declined on your calendar',
        },
        {
          title: 'Auto-accept Invites',
          description: 'Automatically accept meeting invitations',
        },
      ],
      'event-types': [
        {
          title: 'Event Types',
          description: 'Configure different types of events for your calendar',
        },
        {
          title: 'Type color',
        },
      ],
      'host-roles': [
        {
          title: 'Host Roles',
          description: 'Configure host roles used across events',
        },
      ],
      reminders: [
        {
          title: 'Default Reminders',
          description: 'Configure default reminder settings for new events',
        },
        {
          title: 'Default Reminder Time',
        },
        {
          title: 'Enable Reminders',
          description: 'Automatically add reminders to new events',
        },
      ],
      'roles-permissions': [
        {
          title: 'Roles & Permissions',
          description:
            'Customize event record roles, fields, and attendee-facing capabilities',
        },
        {
          title: 'Default access',
        },
        {
          title: 'Admins inherit',
        },
        {
          title: 'Members inherit',
        },
        {
          title: 'No roles loaded yet',
          description: 'Refresh to seed the defaults, or create a custom role.',
        },
        {
          title: 'Role name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Allowed keys',
        },
        {
          title: 'Denied keys',
        },
      ],
      'session-types': [
        {
          title: 'Session Types',
          description: 'Configure formats like keynotes, panels, and workshops',
        },
      ],
      'speaker-roles': [
        {
          title: 'Session Speaker Roles',
          description: 'Configure speaker roles assigned to sessions',
        },
      ],
    },
    '/expenses': {
      categories: [
        {
          title: 'Categories',
        },
      ],
      'payment-methods': [
        {
          title: 'Payment Methods',
        },
      ],
      statuses: [
        {
          title: 'Statuses',
        },
        {
          title: "This pipeline isn't in canonical order",
        },
        {
          title: 'Win probability',
        },
      ],
    },
    '/financials': {
      'budget-categories': [
        {
          title: 'Budget Categories',
          description:
            'Define the categories used to allocate hours and costs in project budgets',
        },
        {
          title: 'Name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Display order',
        },
        {
          title: 'Set as default category',
        },
      ],
      'budget-templates': [
        {
          title: 'Budget Templates',
          description:
            'Reusable budget structures with default category splits',
        },
        {
          title: 'Rules',
        },
        {
          title: 'Name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Set as default template',
        },
        {
          title: 'Category',
        },
        {
          title: 'Default percent (%)',
        },
        {
          title: 'Default hours',
        },
      ],
      overhead: [
        {
          title: 'Overhead',
          description: 'Configure overhead cost categories and allocation',
        },
        {
          title: 'Overhead Categories',
        },
        {
          title: 'Name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Monthly cost ( )',
        },
        {
          title: 'Allocation method',
        },
      ],
    },
    '/invoices': {
      content: [
        {
          title: 'Content',
          description: 'Default text that appears on every new invoice',
        },
        {
          title: 'Default notes',
        },
        {
          title: 'Default terms & conditions',
        },
      ],
      defaults: [
        {
          title: 'Invoice Defaults',
          description:
            "Defaults applied to new invoices. A client's billing profile can override them per client.",
        },
        {
          title: 'Currency',
          description: 'Default currency for new invoices',
        },
        {
          title: 'Payment terms',
          description: 'Drives the default due date',
        },
        {
          title: 'Tax rate',
          description: 'Default tax rate percentage',
        },
        {
          title: 'Card surcharge',
          description:
            'Percentage offered as a one-click surcharge line for card-paying clients',
        },
        {
          title: 'Show company logo',
          description: 'Display your logo on invoice PDFs',
        },
        {
          title: 'Show payment instructions',
          description: 'Display payment instructions on invoice PDFs',
        },
      ],
      'online-payments': [
        {
          title: 'Online payments',
          description:
            'Let clients pay invoices by card or bank transfer through your own Stripe account.',
        },
        {
          title: 'Stripe account',
        },
        {
          title: 'Stripe needs more details',
        },
        {
          title: 'Card payments',
        },
        {
          title: 'ACH bank payments',
        },
        {
          title: 'Connect Stripe',
        },
        {
          title: 'Invoices',
        },
        {
          title: 'Accept online payments',
        },
      ],
      payments: [
        {
          title: 'Payments',
          description: 'How clients can pay their invoices',
        },
        {
          title: 'Accepted payment methods',
        },
        {
          title: 'Bank transfer details',
          description: 'Shown on invoices when bank transfer is enabled',
        },
        {
          title: 'Bank name',
        },
        {
          title: 'Account name',
        },
        {
          title: 'Account number',
        },
        {
          title: 'Routing number',
        },
        {
          title: 'SWIFT/BIC code',
        },
        {
          title: 'PayPal',
        },
        {
          title: 'PayPal email',
        },
        {
          title: 'Payment instructions',
          description:
            'Additional instructions shown to clients making payments',
        },
      ],
      send: [
        {
          title: 'Send & Reminders',
          description:
            'Defaults for the email that delivers an invoice, and overdue reminders',
        },
        {
          title: 'Email template',
        },
        {
          title: 'Subject',
        },
        {
          title: 'Message',
        },
        {
          title: 'Reminders',
        },
        {
          title: 'Late payment reminders',
          description: 'Automatically remind clients about overdue invoices',
        },
        {
          title: 'Reminder schedule',
          description: 'Days after the due date, comma-separated',
        },
      ],
    },
    '/knowledge-base': {
      '*': [
        {
          title: 'Access restricted',
        },
        {
          title: 'Delivery channels',
        },
        {
          title: 'Team',
        },
        {
          title: 'Client portal',
        },
        {
          title: 'Public',
        },
        {
          title: 'Public knowledge base',
          description:
            'Your knowledge base is public at the link below when enabled.',
        },
        {
          title: 'Enable public knowledge base',
        },
        {
          title: 'Public link',
        },
        {
          title: 'Title',
        },
        {
          title: 'Description',
        },
        {
          title: 'Accent color',
        },
        {
          title: 'Accent color value',
        },
        {
          title: 'Roles & permissions',
          description:
            'Record roles used when restricting individual articles with Manage access.',
        },
        {
          title: 'Default access',
        },
        {
          title: 'Admins inherit',
        },
        {
          title: 'Members inherit',
        },
        {
          title: 'No roles loaded yet',
          description: 'Refresh to seed the defaults, or create a custom role.',
        },
        {
          title: 'Role name',
        },
        {
          title: 'Allowed keys',
        },
        {
          title: 'Denied keys',
        },
      ],
    },
    '/products': {
      'category-types': [
        {
          title: 'Category Types',
          description:
            'Manage the options shown in the Type dropdown when creating an inventory category',
        },
        {
          title: 'Name',
        },
        {
          title: 'Code',
        },
        {
          title: 'Description',
        },
      ],
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional inventory item details',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      'movement-reasons': [
        {
          title: 'Movement Reasons',
        },
        {
          title: 'Name',
        },
        {
          title: 'Code',
        },
        {
          title: 'Applies to',
        },
        {
          title: 'Description',
        },
      ],
      'roles-permissions': [
        {
          title: 'Roles & Permissions',
          description:
            'Customize inventory record roles, fields, and stock-value capabilities',
        },
        {
          title: 'Default access',
        },
        {
          title: 'Admins inherit',
        },
        {
          title: 'Members inherit',
        },
        {
          title: 'No roles loaded yet',
          description: 'Refresh to seed the defaults, or create a custom role.',
        },
        {
          title: 'Role name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Allowed keys',
        },
        {
          title: 'Denied keys',
        },
      ],
    },
    '/projects': {
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information about projects',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      cycles: [
        {
          title: 'Cycle Templates',
        },
        {
          title: 'Name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Cycle period',
        },
        {
          title: 'Start date',
        },
        {
          title: 'End date',
        },
        {
          title: 'When current cycle completes',
          description: 'Auto-create next cycle when one is marked complete',
        },
        {
          title: 'Automatically ahead of time',
          description: 'Generate the next cycle before the current one ends',
        },
        {
          title: 'Carry forward incomplete tasks',
          description: 'Move unfinished tasks to the next cycle',
        },
      ],
      defaults: [
        {
          title: 'Default Settings',
          description: 'Configure default values for new projects',
        },
        {
          title: 'Default Values',
          description:
            'Initial type and timeline applied to newly created projects.',
        },
        {
          title: 'Default Project Type',
        },
        {
          title: 'Default Duration (days)',
        },
        {
          title: 'Project Codes',
          description:
            'Configure how project codes are generated and archived.',
        },
        {
          title: 'Project Code Prefix',
        },
        {
          title: 'Auto-archive After (days)',
        },
        {
          title: 'Project Behavior',
          description: 'Toggle features and validation rules for new projects.',
        },
        {
          title: 'Require Project Code',
          description: 'Require a unique project code for all projects',
        },
        {
          title: 'Enable Timeline',
          description: 'Enable timeline/Gantt view for new projects by default',
        },
      ],
      notifications: [
        {
          title: 'Notifications',
        },
        {
          title: 'Watched Projects',
          description:
            'Watch a project from its header to get notified about activity in it.',
        },
        {
          title: 'Channels & devices',
        },
        {
          title: 'Show badge count',
        },
        {
          title: 'Group notifications',
        },
        {
          title: 'Show action buttons',
        },
        {
          title: 'Keep visible until dismissed',
        },
        {
          title: 'SMS notifications',
          description:
            'Transactional alerts and workflow reminders from Scrambl',
        },
        {
          title: 'Mobile phone number',
        },
        {
          title: 'SMS verification code',
        },
        {
          title: 'Agree to receive transactional SMS messages',
        },
        {
          title: 'Notification sounds',
          description: 'Play a sound when new messages arrive in threads',
        },
        {
          title: 'Notification types',
        },
        {
          title: 'Remind me before due date',
        },
      ],
      personal: [
        {
          title: 'My Preferences',
          description: 'These settings only affect your account',
        },
        {
          title: 'Default Tab',
          description: 'Choose which tab opens by default when you view a .',
        },
        {
          title: 'Open records on',
        },
      ],
      'roles-permissions': [
        {
          title: 'Roles & Permissions',
          description:
            'Customize project record roles, tabs, features, and sensitive field capabilities',
        },
        {
          title: 'Default access',
        },
        {
          title: 'Admins inherit',
        },
        {
          title: 'Members inherit',
        },
        {
          title: 'No roles loaded yet',
          description: 'Refresh to seed the defaults, or create a custom role.',
        },
        {
          title: 'Role name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Allowed keys',
        },
        {
          title: 'Denied keys',
        },
      ],
      statuses: [
        {
          title: 'Project Statuses',
          description: 'Configure the status options available for projects',
        },
        {
          title: "This pipeline isn't in canonical order",
        },
        {
          title: 'Win probability',
        },
      ],
      'task-types': [
        {
          title: 'Task Types',
        },
        {
          title: 'Enabled',
        },
        {
          title: 'Default priority',
          description: 'Applied to new tasks of this type.',
        },
        {
          title: 'Capabilities',
        },
        {
          title: 'SLA target (minutes)',
        },
        {
          title: 'Org default statuses',
          description:
            'Save this new type first, then configure its org default statuses here.',
        },
        {
          title: 'Reassign tasks to',
        },
      ],
    },
    '/quotes': {
      '*': [
        {
          title: 'Invoice on acceptance',
          description: 'What happens when a client accepts and signs a quote.',
        },
      ],
    },
    '/suppliers': {
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information about .',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      lifecycle: [
        {
          title: 'Lifecycle Stages',
        },
        {
          title: "This pipeline isn't in canonical order",
        },
        {
          title: 'Win probability',
        },
      ],
      'payment-terms': [
        {
          title: 'Payment Terms',
        },
        {
          title: 'Name',
        },
        {
          title: 'Net days',
        },
        {
          title: 'Description',
        },
      ],
      'roles-permissions': [
        {
          title: 'Roles & Permissions',
          description:
            'Customize record roles, fields, and sensitive procurement capabilities.',
        },
        {
          title: 'Default access',
        },
        {
          title: 'Admins inherit',
        },
        {
          title: 'Members inherit',
        },
        {
          title: 'No roles loaded yet',
          description: 'Refresh to seed the defaults, or create a custom role.',
        },
        {
          title: 'Role name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Allowed keys',
        },
        {
          title: 'Denied keys',
        },
      ],
    },
    '/tasks/mine': {
      'recycle-bin': [
        {
          title: 'My Tasks Recycle Bin',
          description: 'Review and restore deleted private personal tasks.',
        },
        {
          title: 'Open Recycle Bin',
          description:
            'Restore private personal tasks deleted from your My Tasks list.',
        },
      ],
      statuses: [
        {
          title: 'Personal Task Statuses',
        },
        {
          title: "This pipeline isn't in canonical order",
        },
        {
          title: 'Win probability',
        },
      ],
      templates: [
        {
          title: 'Task Templates',
        },
        {
          title: 'Save work you repeat',
        },
        {
          title: 'Name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Category',
        },
        {
          title: 'Priority',
        },
        {
          title: 'Parent task due',
        },
      ],
    },
    '/team': {
      allocation: [
        {
          title: 'Allocation Policies',
          description: 'Configure rules and limits for resource allocations',
        },
        {
          title: 'Maximum Allocation (%)',
        },
        {
          title: 'Conflict Warning Threshold (%)',
        },
        {
          title: 'Allow Overbooking',
          description: 'Allow allocations that exceed 100% capacity',
        },
        {
          title: 'Require Approval',
          description: 'New allocations require manager approval',
        },
        {
          title: 'Allocation lifecycle',
          description: 'Defaults and automation for allocation states (Plan 4)',
        },
        {
          title: 'Default status for new allocations',
        },
        {
          title: 'Default max projects per member',
        },
        {
          title: 'Auto-archive grace days',
        },
        {
          title: 'Placeholder review days',
        },
        {
          title: 'Auto-archive past allocations',
          description:
            'Nightly job archives allocations after their end-date (plus grace days)',
        },
        {
          title: 'Confirm placeholder assignments',
        },
        {
          title: 'Allocation Constraints',
          description:
            'Define rules that warn or block allocations based on configurable thresholds.',
        },
        {
          title: 'No constraints defined',
        },
        {
          title: 'Constraint type',
        },
        {
          title: 'Threshold',
        },
        {
          title: 'Action',
        },
        {
          title: 'Message',
        },
        {
          title: 'Applies to role',
        },
        {
          title: 'Applies to employment type',
        },
      ],
      'billing-configuration': [
        {
          title: 'Billing Configuration',
          description:
            'Control when billing roles must be intentionally configured before billable time is used',
        },
        {
          title: 'Billing Role Enforcement',
        },
        {
          title: 'Require billing configuration for billable time',
        },
        {
          title: 'Enforcement Mode',
        },
        {
          title: 'Record Types',
          description:
            'Choose which supported bill-to scopes require billing configuration.',
        },
      ],
      compensation: [
        {
          title: 'Compensation',
          description:
            'Configure payroll defaults, tax items, and benefit templates',
        },
        {
          title: 'Payroll Defaults',
          description:
            'Organization-wide default settings for payroll calculations',
        },
        {
          title: 'Default Hours/Week',
        },
        {
          title: 'Pay Periods/Year',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Tax Items',
          description:
            'Configure employer and employee tax rates for payroll calculations',
        },
        {
          title: 'No tax items configured',
        },
        {
          title: 'Name',
        },
        {
          title: 'Code',
        },
        {
          title: 'Tax type',
        },
        {
          title: 'Rate (%)',
        },
        {
          title: 'Wage base limit ($)',
        },
        {
          title: 'Benefit Templates',
          description:
            'Organization-wide benefit options that can be assigned to members',
        },
        {
          title: 'No benefit templates configured',
        },
        {
          title: 'Benefit type',
        },
        {
          title: 'Employer amount ($/period)',
        },
        {
          title: 'Employee amount ($/period)',
        },
        {
          title: 'Match percent (%)',
        },
        {
          title: 'Match up to (%)',
        },
        {
          title: 'Rate Sync',
        },
      ],
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information about team members',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      'default-rates': [
        {
          title: 'Default Rates',
        },
        {
          title: 'Default Bill Rate ($/hr)',
        },
        {
          title: 'Default Cost Rate ($/hr)',
        },
        {
          title: 'Default Pay Rate ($/hr)',
        },
        {
          title: 'Backfill Historical Rates',
        },
        {
          title: 'All entries without stored rates',
        },
        {
          title: 'Specific date range',
        },
        {
          title: 'Specific project',
        },
        {
          title: 'From',
        },
        {
          title: 'Backfilling rates...',
          description: 'This may take a moment',
        },
        {
          title: 'Backfill complete',
        },
        {
          title: 'Nothing to backfill',
          description: 'No time entries in this scope are missing a rate.',
        },
        {
          title: 'Before you run',
        },
      ],
      holidays: [
        {
          title: 'Organization Holidays',
          description:
            'Manage holidays that apply to all team members. Recurring holidays repeat every year.',
        },
        {
          title: 'Holidays',
          description:
            'Holidays will appear in the team schedule and affect availability calculations',
        },
        {
          title: 'No holidays configured',
        },
        {
          title: 'Suggested holidays',
          description:
            'Common US holidays. Floating holidays (e.g. Thanksgiving) recalculate each year.',
        },
        {
          title: 'Holiday name',
        },
        {
          title: 'Date',
        },
        {
          title: 'Recurring holiday',
          description: 'This holiday repeats every year on the same date',
        },
      ],
      'roles-permissions': [
        {
          title: 'Roles & Permissions',
          description:
            'Customize scoped team record roles, compensation fields, and sensitive capabilities',
        },
        {
          title: 'Default access',
        },
        {
          title: 'Admins inherit',
        },
        {
          title: 'Members inherit',
        },
        {
          title: 'No roles loaded yet',
          description: 'Refresh to seed the defaults, or create a custom role.',
        },
        {
          title: 'Role name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Allowed keys',
        },
        {
          title: 'Denied keys',
        },
      ],
      skills: [
        {
          title: 'Skills Settings',
          description: 'Configure skill tracking and certification settings',
        },
        {
          title: 'Enable Proficiency Levels',
          description: 'Track skill proficiency on a 1-5 scale',
        },
        {
          title: 'Enable Certifications',
          description:
            'Allow tracking of skill certifications and expiry dates',
        },
        {
          title: 'Require Skill Approval',
          description:
            'Manager approval required when members claim new skills',
        },
      ],
      'team-defaults': [
        {
          title: 'Team Defaults',
          description:
            'Set default utilization targets and work capacity for new team members',
        },
        {
          title: 'Default Targets',
          description:
            'These targets will be applied as defaults for new team member profiles',
        },
        {
          title: 'Target Utilization (%)',
        },
        {
          title: 'Target Billable (%)',
        },
        {
          title: 'Weekly Capacity',
          description: 'Default hours per week for different employment types',
        },
        {
          title: 'Full-Time (hours/week)',
        },
        {
          title: 'Part-Time (hours/week)',
        },
        {
          title: 'Contractor (hours/week)',
        },
        {
          title: 'Freelancer (hours/week)',
        },
      ],
      'utilization-definitions': [
        {
          title: 'Utilization Definitions',
        },
        {
          title: 'Primary Utilization Metric',
        },
        {
          title: 'Margin Threshold (%)',
        },
        {
          title: 'Revenue Target Multiplier',
        },
        {
          title: 'Burnout Streak Threshold (weeks)',
        },
        {
          title: 'Staleness Threshold (hours)',
        },
        {
          title: 'Nightly Recalculation Time',
        },
        {
          title: 'Burnout Notifications',
        },
        {
          title: 'Productive categories',
        },
        {
          title: 'Revenue / Profit Card Tier',
        },
        {
          title: 'Financial Actuals',
          description:
            'Approved time only — matches payroll and invoicing. Default.',
        },
        {
          title: 'Operational Visibility',
          description:
            'All time (submitted + approved) — broader picture for planning.',
        },
      ],
    },
    '/tickets': {
      alerts: [
        {
          title: 'Ticket Alerts',
          description:
            'Choose who gets notified when new tickets arrive from forms, the client portal, or email.',
        },
      ],
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add support-specific fields that appear on ticket records and forms.',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      defaults: [
        {
          title: 'Default source',
          description: 'Internal app and Forms intake',
        },
        {
          title: 'Requester model',
          description: 'Requester snapshot with optional linked records',
        },
        {
          title: 'Assignment model',
          description: 'Multiple assignees plus followers',
        },
        {
          title: 'Escalation model',
          description: 'Due dates and workflow triggers',
        },
        {
          title: 'Ticket Defaults',
          description:
            'Review the system-managed defaults applied when tickets are created.',
        },
      ],
      domains: [
        {
          title: 'Email Domains',
        },
        {
          title: 'Domains',
        },
        {
          title: 'BIMI (Brand logo in inbox)',
        },
        {
          title: 'Logo (SVG Tiny PS 1.2)',
        },
        {
          title: 'VMC certificate URL (optional, required by Gmail)',
        },
        {
          title: 'Publish this TXT record',
        },
      ],
      'email-intake': [
        {
          title: 'Email Inboxes',
        },
        {
          title: 'Your inboxes',
        },
        {
          title: 'DMARC health',
        },
        {
          title: 'Forward from your own support address',
        },
        {
          title: 'Google Workspace — easy method (Recipient address map)',
        },
        {
          title: 'Open Gmail Routing',
        },
        {
          title: 'Scroll to Recipient address map → Configure',
        },
        {
          title: 'Description (required)',
        },
        {
          title: '1. Map original recipient to new recipient',
        },
        {
          title: '2. Messages to affect',
        },
        {
          title: '3. Routing options',
        },
        {
          title: '4. Options (recommended)',
        },
        {
          title: 'Save and verify',
        },
        {
          title: 'Google Workspace — advanced (custom Routing rule)',
        },
        {
          title: 'Open Gmail Routing → Routing card',
        },
        {
          title: '1. Email messages to affect',
        },
        {
          title: '2. For the above types of messages, do the following',
        },
        {
          title: 'Account types this action should apply to',
        },
        {
          title: 'Envelope recipient — redirect to Scrambl',
        },
        {
          title: 'Scroll to the bottom and click "Show options"',
        },
        {
          title: 'Envelope filter — limit to your support address',
        },
        {
          title: 'Everything else stays unchecked',
        },
        {
          title: 'Microsoft 365 (Exchange)',
        },
        {
          title: 'Open Mail flow rules',
        },
        {
          title: 'Create a redirect rule',
        },
        {
          title: 'Match your support address',
        },
        {
          title: 'Redirect to Scrambl',
        },
        {
          title: 'Enforce and save',
        },
        {
          title: 'Start from a common pattern',
        },
        {
          title: 'Display name',
        },
        {
          title: 'Mailbox name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Linked',
        },
        {
          title: 'Strip signatures from incoming email',
        },
        {
          title: 'Max open tickets per member',
        },
        {
          title: 'Description template',
        },
        {
          title: 'Customer-side addresses that forward here',
        },
      ],
      macros: [
        {
          title: 'Macros',
        },
        {
          title: 'Shared macros',
        },
        {
          title: 'Personal macros',
          description: 'Private saved replies only you can see and insert.',
        },
        {
          title: 'Name',
        },
        {
          title: 'Scope',
        },
        {
          title: 'Reply body',
        },
        {
          title: 'Description',
        },
        {
          title: 'Set stage',
        },
        {
          title: 'Set priority',
        },
        {
          title: 'Add tags',
        },
        {
          title: 'Assign members',
        },
        {
          title: 'Add followers',
        },
        {
          title: 'Enabled',
          description:
            'Disabled macros stay here but are hidden from the composer picker.',
        },
      ],
      'recycle-bin': [
        {
          title: 'Ticket Recycle Bin',
          description:
            'Review and restore tickets moved out of the active workspace.',
        },
        {
          title: 'Open Recycle Bin',
          description:
            'Deleted tickets are kept here and can be restored by users with ticket update access.',
        },
      ],
      sources: [
        {
          title: 'Ticket Sources',
          description: 'Create and manage the source options used by tickets.',
        },
      ],
      suppressions: [
        {
          title: 'Suppression list',
        },
        {
          title: 'Suppressed recipients',
        },
      ],
      'ticket-types': [
        {
          title: 'Ticket Types & Stages',
        },
        {
          title: 'Default stages',
        },
        {
          title: "This pipeline isn't in canonical order",
        },
        {
          title: 'Enabled',
        },
        {
          title: 'Description',
        },
        {
          title: 'Icon',
        },
        {
          title: 'Color',
        },
        {
          title: 'Form fields',
        },
        {
          title: 'Default assignee',
          description:
            'New tickets of this type with no assignee are routed to this person.',
        },
        {
          title: 'Capabilities',
        },
        {
          title: 'Strategy',
        },
        {
          title: 'Assignee pool',
        },
        {
          title: 'Max open tickets per member',
        },
        {
          title: 'Satisfaction survey',
          description:
            'Email the requester a one-click satisfaction survey when the ticket is resolved.',
        },
        {
          title: 'Workflow stages',
          description:
            'Save this new type first, then configure its workflow stages here.',
        },
        {
          title: 'Match default',
        },
        {
          title: 'Custom',
        },
        {
          title: 'Task sync',
        },
      ],
      widget: [
        {
          title: 'Customer intake widgets',
        },
        {
          title: 'Basics',
          description: 'Internal name + the form your customers fill out.',
        },
        {
          title: 'Name',
        },
        {
          title: 'Status',
        },
        {
          title: 'Form',
        },
        {
          title: 'Chat',
          description:
            'Adds a chat tab to this widget. Configure chat behavior in Live chat → Settings.',
        },
        {
          title: 'Icon',
        },
        {
          title: 'Appearance',
          description:
            'Visible to anyone who loads your site. Changes take effect on next reload.',
        },
        {
          title: 'Primary color',
        },
        {
          title: 'Position',
        },
        {
          title: 'Greeting',
        },
        {
          title: 'Routing',
        },
        {
          title: 'Inbox',
        },
        {
          title: 'Embed snippet',
        },
        {
          title: 'Danger zone',
        },
      ],
    },
    '/timesheets': {
      approvals: [
        {
          title: 'Approval Workflow',
          description: 'Configure how time entries are reviewed and approved',
        },
        {
          title: 'Submission & Locking',
          description:
            'Submission, approval, and locking behavior for the pay period',
        },
        {
          title: 'Require Approval',
          description:
            'Time entries must be submitted and approved before they count',
        },
        {
          title: 'Auto-Submit on Period Close',
          description:
            'Automatically submit all draft entries when the pay period closes',
        },
        {
          title: 'Lock Entries on Period Close',
          description:
            'Prevent any changes to entries after the pay period closes',
        },
        {
          title: 'Block New Entries After Submit',
        },
        {
          title: 'Allow Edit After Approval',
          description: 'Allow editing approved entries (requires re-approval)',
        },
        {
          title: 'Approval Deadline (days)',
        },
        {
          title: 'Approver Configuration',
          description: 'Configure who can approve time entries',
        },
        {
          title: 'Project Owners Can Approve',
          description:
            'Project owners can approve time entries for their projects',
        },
        {
          title: 'Managers Can Approve',
          description:
            'Managers can approve time entries for their direct reports',
        },
      ],
      'bill-to': [
        {
          title: 'Bill To Configuration',
          description:
            'Control which types of records team members can log time against and bill to',
        },
        {
          title: 'Allowed Bill-To Types',
        },
      ],
      'contractor-invoices': [
        {
          title: 'Contractor Invoices',
          description: 'Choose exactly who receives contractor invoice emails',
        },
        {
          title: 'Pay',
          description:
            'How contractors and freelancers are paid for their time',
        },
        {
          title: 'Contractor pay basis',
        },
        {
          title: 'Automation',
          description: 'Generate and send contractor invoices automatically',
        },
        {
          title: 'Auto-Submit Contractor Invoices',
        },
        {
          title: 'Send Delay After Period Ends (days)',
        },
        {
          title: 'Email Recipients',
          description:
            'Contractor invoice emails are sent only to the active members selected here',
        },
        {
          title: 'Invoice Eligibility',
        },
        {
          title: 'Recipients',
        },
      ],
      'custom-fields': [
        {
          title: 'Custom Fields',
          description:
            'Add custom fields to capture additional information on time entries',
        },
        {
          title: 'Active',
        },
        {
          title: 'Archived',
        },
        {
          title: 'Field name',
        },
        {
          title: 'Similar fields may already exist',
        },
        {
          title: 'Field type',
        },
        {
          title: 'Make available to all projects',
        },
        {
          title: 'Field access',
        },
        {
          title: 'All readers',
        },
        {
          title: 'Link to',
          description:
            'Pick standard modules or a specific collection from one list.',
        },
        {
          title: 'Currency',
        },
        {
          title: 'Formula',
        },
        {
          title: 'Result format',
        },
        {
          title: 'Lookup',
        },
        {
          title: 'Get data from',
        },
        {
          title: "Where this record's field",
        },
        {
          title: 'Matches a record in',
        },
        {
          title: 'On its field',
        },
        {
          title: 'Show field',
        },
        {
          title: 'Rollup',
        },
        {
          title: 'Related records',
        },
        {
          title: 'Calculate',
        },
        {
          title: 'Of field',
        },
        {
          title: 'Options',
        },
        {
          title: 'Option source',
        },
      ],
      'entry-rules': [
        {
          title: 'Entry Rules',
          description: 'Configure defaults and validation for time entries',
        },
        {
          title: 'Entry Defaults',
          description:
            'What members can enter and how new entries behave by default',
        },
        {
          title: 'Allow Manual Entries',
          description: 'Enable entries created by typing total hours',
        },
        {
          title: 'Allow Timer Entries',
          description: 'Enable entries created with start and end times',
        },
        {
          title: 'Default Billable',
          description: 'New entries are billable by default',
        },
        {
          title: 'Internal time is billable',
          description: 'Time logged to your organization or without a client',
        },
        {
          title: 'Allow Future Entries',
          description: 'Permit entries dated in the future',
        },
        {
          title: 'Double-Tracking (Overlapping Entries)',
        },
        {
          title: 'Time categories',
          description:
            'Kinds of work members pick on entries. Their billable default beats project and client.',
        },
        {
          title: 'Billable',
        },
        {
          title: 'Required Entry Information',
          description: 'At least one option must be enabled',
        },
        {
          title: 'Require Description',
          description: 'Require a description for every entry',
        },
        {
          title: 'Require Module Link',
          description: 'Require entries to be linked to an enabled record',
        },
        {
          title: 'Entry Limits',
          description:
            'Validation thresholds applied when members create or edit entries',
        },
        {
          title: 'Minimum Duration (minutes)',
        },
        {
          title: 'Rounding Interval (minutes)',
        },
        {
          title: 'Max Hours Per Entry',
        },
        {
          title: 'Default Status',
        },
      ],
      'expected-hours': [
        {
          title: 'Expected Hours',
          description:
            'Configure timesheet hour expectations and missing-timesheet checks',
        },
        {
          title: 'Employment-Type Defaults',
          description:
            'Members without a weekly capacity override inherit these Team Settings defaults',
        },
        {
          title: 'Expected Hours Warnings',
          description:
            'Missing-timesheet checks compare logged time against expected hours',
        },
        {
          title: 'Warn Below Expected Hours',
          description:
            'Warn members when logged hours are below the expected threshold',
        },
        {
          title: 'Expected Hours Threshold (%)',
        },
        {
          title: 'Send Missing Timesheet Reminders',
          description:
            'Remind members who are below expected hours for the period',
        },
      ],
      maintenance: [
        {
          title: 'Maintenance',
          description:
            'Tools to repair timesheet data if something gets out of sync',
        },
        {
          title: 'Recalculate Historical Utilization',
          description:
            'Rebuild stored timesheet-derived utilization and earnings data for this organization',
        },
        {
          title: 'Sync Time Period Links',
        },
      ],
      notifications: [
        {
          title: 'Notifications',
          description: 'Configure time-related notifications',
        },
        {
          title: 'Time Notifications',
          description:
            'Reminders and warnings for missed or low-volume timesheets',
        },
        {
          title: 'Notify on Submission',
          description: 'Notify approvers when time entries are submitted',
        },
        {
          title: 'Notify on Approval',
          description: 'Notify team members when their entries are approved',
        },
        {
          title: 'Notify on Rejection',
          description: 'Notify team members when their entries are rejected',
        },
        {
          title: 'Reminder Days Before Close',
        },
      ],
      'pay-period': [
        {
          title: 'Pay Period Configuration',
        },
        {
          title: 'Auto-Create Pay Periods',
          description:
            'Automatically create pay periods as needed when none exists for the current date',
        },
        {
          title: 'Pay Period Type',
        },
        {
          title: 'Week Start Day',
        },
        {
          title: 'First Pay Period Start',
        },
        {
          title: 'First Period Start Day',
        },
        {
          title: 'Second Period Start Day',
        },
      ],
      'time-format': [
        {
          title: 'Time Format',
        },
      ],
    },
  },
  pages: {
    'admin:/admin/archive': {
      '*': [
        {
          title: 'Could not load the archive',
          description:
            'The archive requires an owner or admin role on this organization.',
        },
        {
          title: 'Select all restorable records',
        },
      ],
    },
    'admin:/admin/data': {
      '*': [
        {
          title: 'Bring your data',
        },
        {
          title: 'Connect directly',
        },
        {
          title: 'People',
        },
        {
          title: 'Reconciliation',
        },
        {
          title: 'Account ID',
        },
        {
          title: 'Personal access token',
        },
        {
          title: 'Time and invoices from (optional)',
        },
        {
          title: 'Include archived clients and projects',
        },
        {
          title: 'Harvest',
        },
        {
          title: 'Have us move it for you',
        },
        {
          title: 'Moving from',
        },
        {
          title: 'Which tool?',
        },
        {
          title: 'Their plan (optional)',
        },
        {
          title: 'Account address or region (optional)',
        },
        {
          title: 'History from',
        },
        {
          title: 'Invoices since',
        },
        {
          title: 'Target cutover date',
        },
        {
          title: 'How do you bill?',
        },
        {
          title: 'Your time zone',
        },
        {
          title: 'Custom fields you rely on (optional)',
        },
        {
          title: 'Days we should avoid (optional)',
        },
        {
          title: 'Primary contact',
        },
        {
          title: 'Primary contact email',
        },
        {
          title: 'Backup contact (optional)',
        },
        {
          title: 'Backup contact email',
        },
        {
          title: 'Anything else? (optional)',
        },
      ],
    },
    'admin:/admin/integrations': {
      '*': [
        {
          title: 'Slack',
          description:
            'Notifications, channel alerts, link previews, and Benny in Slack.',
        },
        {
          title: 'Notifications',
          description: 'Deliver notifications as Slack DMs',
        },
        {
          title: 'Benny in Slack',
          description: 'Answer @Scrambl mentions and DMs',
        },
        {
          title: 'Link previews',
          description: 'Preview Scrambl links shared in Slack',
        },
        {
          title: 'GitHub',
          description:
            'Link repositories to projects and open branches and pull requests from tasks.',
        },
        {
          title: 'Stripe Payments',
          description:
            'Let clients pay invoices by card or bank transfer through your own Stripe account.',
        },
        {
          title: 'Connected',
        },
        {
          title: 'Outbound webhooks',
          description: 'Send signed events to your own services and agents.',
        },
        {
          title: 'Connect your first endpoint',
        },
        {
          title: 'Name',
        },
        {
          title: 'Endpoint URL',
        },
        {
          title: 'Receive live events',
        },
        {
          title: 'Verify signatures · Node.js',
        },
        {
          title: 'Channel',
        },
        {
          title: 'Scope',
        },
        {
          title: 'Events',
        },
      ],
      quickbooks: [
        {
          title: 'Overview',
          description: 'Connection status and company info',
        },
        {
          title: 'Sync Modules',
          description: 'Enable or disable sync modules',
        },
        {
          title: 'Customer Links',
          description: 'Link QuickBooks customers to',
        },
        {
          title: 'Invoices',
          description: 'Invoice import and contract linking',
        },
        {
          title: 'Time Entries',
          description: 'Time activity sync settings',
        },
        {
          title: 'QuickBooks Overview',
          description: 'Connection status, company details, and health checks.',
        },
        {
          title: 'QuickBooks Customer',
        },
        {
          title: 'Current Links',
        },
        {
          title: 'Invoice Imports',
          description:
            'QuickBooks invoices import into Scrambl (two-way sync coming soon).',
        },
        {
          title: 'Link invoices to active contracts',
        },
        {
          title: 'Time Entry Sync',
          description:
            'Control how QuickBooks time activities sync to Scrambl.',
        },
        {
          title: 'Import time activities',
          description:
            'Bring QuickBooks time activities into Scrambl time entries.',
        },
        {
          title: 'Export time entries',
          description: 'Send approved Scrambl time entries to QuickBooks.',
        },
        {
          title: 'QuickBooks Not Connected',
          description: 'Connect QuickBooks to configure sync settings.',
        },
        {
          title: 'Access required',
          description:
            "You don't have permission to view integration settings.",
        },
      ],
    },
    'admin:/admin/logs': {
      '*': [
        {
          title: 'Activity',
        },
        {
          title: 'Could not load the audit trail',
          description:
            'Audit access requires an owner or admin role on this organization.',
        },
        {
          title: 'Retention status unavailable',
          description: 'The audit retention endpoint could not be reached.',
        },
        {
          title: 'Retention policies',
        },
        {
          title: 'No retention policies configured',
        },
        {
          title: 'User ID',
        },
        {
          title: 'Impersonator ID',
        },
        {
          title: 'Agent account ID',
        },
        {
          title: 'Entity',
        },
        {
          title: 'Name',
        },
        {
          title: 'Entity ID',
        },
        {
          title: 'Module',
        },
        {
          title: 'Module ID',
        },
        {
          title: 'Details',
        },
        {
          title: 'Duration',
        },
        {
          title: 'Reason',
        },
        {
          title: 'Approved by',
        },
        {
          title: 'Ticket',
        },
        {
          title: 'IP address',
        },
        {
          title: 'User agent',
        },
        {
          title: 'Request ID',
        },
        {
          title: 'Session ID',
        },
        {
          title: 'Audit ID',
        },
        {
          title: 'From',
        },
        {
          title: 'Record type',
        },
        {
          title: 'Format',
        },
        {
          title: 'Standard',
        },
        {
          title: 'Include details',
          description: 'Ask the server for the expanded report body.',
        },
      ],
    },
    'admin:/admin/members': {
      '*': [
        {
          title: 'Members',
        },
        {
          title: 'Access Levels',
        },
        {
          title: 'External Organizations',
        },
        {
          title: 'Status',
        },
        {
          title: 'Role',
        },
        {
          title: 'Access Level',
        },
        {
          title: 'Describe the filter',
        },
        {
          title: 'Pending Invitations',
        },
        {
          title: 'The following records will be anonymized:',
        },
        {
          title: 'System sets',
        },
        {
          title: 'Custom sets',
        },
        {
          title: "What they'll see",
          description:
            'The sidebar this member gets. Areas light up as you grant access.',
        },
        {
          title: 'Start from a template',
        },
        {
          title: 'Name',
        },
        {
          title: 'Description',
        },
        {
          title: 'Module',
        },
        {
          title: 'Actions',
        },
        {
          title: 'First name',
        },
        {
          title: 'Last name',
        },
        {
          title: 'Email',
        },
        {
          title: 'Job title',
        },
        {
          title: 'Department',
        },
      ],
      agents: [
        {
          title: 'Search agents',
        },
        {
          title: 'Name',
        },
        {
          title: 'Purpose',
        },
        {
          title: 'Instructions & personality',
        },
        {
          title: 'Access level',
        },
        {
          title: 'Allow task assignment',
          description:
            'Show this agent in the assignee picker. Existing assignments stay visible when turned off.',
        },
        {
          title: 'Monthly tool calls',
        },
        {
          title: 'Key name',
        },
      ],
    },
    'admin:/admin/settings': {
      account: [
        {
          title: 'Account',
          description:
            'Manage your account type and grow into a full organization',
        },
        {
          title: 'Account Type',
        },
        {
          title: 'Convert to an organization',
        },
        {
          title: 'Ready to grow?',
          description:
            'This action is safe and reversible by our team if you change your mind.',
        },
      ],
      'comment-moderation': [
        {
          title: 'Comment Moderation',
          description:
            'Control how long members can change their comments after posting.',
        },
        {
          title: 'Comments',
        },
        {
          title: 'Editing comments',
          description:
            'When members can edit a comment they posted. Changes apply right away.',
        },
        {
          title: 'Deleting comments',
          description:
            'When members can delete a comment they posted, or whether replies block it.',
        },
      ],
      finance: [
        {
          title: 'Finance',
          description: 'Fiscal reporting and forecast settings',
        },
        {
          title: 'Fiscal Calendar',
        },
        {
          title: 'Fiscal year starts',
          description: 'Sets fiscal year and quarter ranges in reports.',
        },
        {
          title: 'Forecast cost basis',
        },
      ],
      general: [
        {
          title: 'General',
          description: "Your organization's identity and regional preferences",
        },
        {
          title: 'Organization Profile',
        },
        {
          title: 'Name',
        },
        {
          title: 'URL slug',
        },
        {
          title: 'Description',
        },
        {
          title: 'Regional Preferences',
        },
        {
          title: 'Timezone',
          description: 'Members can override this in their personal settings.',
        },
        {
          title: 'English spelling',
          description:
            'Applied to AI-generated content like meeting summaries.',
        },
        {
          title: 'Terminology',
        },
        {
          title: 'Client terminology',
        },
        {
          title: 'Singular',
        },
        {
          title: 'Plural',
        },
      ],
      'workspace-defaults': [
        {
          title: 'Workspace Defaults',
          description:
            'Defaults applied when your team creates tasks and projects',
        },
        {
          title: 'Tasks',
        },
        {
          title: 'Story points format',
          description: 'How estimates display on SCRUM projects.',
        },
        {
          title: 'Default Status Templates',
          description: 'Applied when creating new projects of each type.',
        },
      ],
    },
    'admin:/admin/subscription': {
      '*': [
        {
          title: 'Current Plan',
        },
        {
          title: 'Billing Period',
        },
        {
          title: 'Next Billing Date',
        },
        {
          title: 'Storage Usage',
        },
        {
          title: 'Team Seats',
          description: 'Manage user access and seat assignments',
        },
        {
          title: 'Total seat count',
        },
        {
          title: 'AI Usage',
        },
        {
          title: 'AI Credits',
        },
        {
          title: 'Top Features',
        },
        {
          title: 'Recent Activity',
        },
        {
          title: 'Add-on Marketplace',
          description:
            'Enhance your subscription with additional features and resources',
        },
        {
          title: 'No Active Subscription',
          description:
            'Choose a plan to unlock premium features for your organization',
        },
        {
          title: 'Plan',
        },
        {
          title: 'Billing',
        },
        {
          title: 'Seats',
        },
      ],
      plans: [
        {
          title: 'Coupon Code',
        },
        {
          title: "What's included:",
        },
      ],
    },
    'personal:profile': {
      account: [
        {
          title: 'Account',
          description:
            'Your Scrambl identity. These details follow you into every organization you belong to.',
        },
        {
          title: 'Floating Benny',
          description:
            'Keep Benny on top of your desktop as a draggable companion.',
        },
        {
          title: 'Toggle floating Benny',
        },
      ],
      appearance: [
        {
          title: 'Appearance',
          description:
            'How Scrambl looks for you, on every device you sign in to.',
        },
        {
          title: 'Color mode',
        },
        {
          title: 'Sidebar theme',
          description:
            'The color of the navigation and title bar. Each theme has a light and a dark face.',
        },
        {
          title: 'Pages in your sidebar',
          description:
            'Only affects your sidebar in this workspace. Your show/hide choices and pins are kept.',
        },
      ],
      integrations: [
        {
          title: 'Integrations available with Pro',
          description:
            'Connect AI assistants, email, calendar, and other services to sync data automatically.',
        },
        {
          title: 'AI Assistants (MCP)',
        },
        {
          title: 'Gmail',
        },
        {
          title: 'Outlook',
        },
        {
          title: 'Google Calendar',
        },
        {
          title: 'AI & Automation',
        },
        {
          title: 'Connected Services',
        },
        {
          title: 'AI assistant access is off',
          description:
            'Turn it on to let AI apps see and update your Scrambl work.',
        },
        {
          title: 'Connections & keys',
        },
        {
          title: 'Search agents',
        },
        {
          title: 'Connected accounts',
        },
        {
          title: 'Workspace link',
        },
        {
          title: 'Connection',
        },
        {
          title: 'What will be synced',
        },
        {
          title: 'Sync capabilities',
        },
      ],
      notifications: [
        {
          title: 'Channels & devices',
        },
        {
          title: 'Show badge count',
        },
        {
          title: 'Group notifications',
        },
        {
          title: 'Show action buttons',
        },
        {
          title: 'Keep visible until dismissed',
        },
        {
          title: 'SMS notifications',
          description:
            'Transactional alerts and workflow reminders from Scrambl',
        },
        {
          title: 'Mobile phone number',
        },
        {
          title: 'SMS verification code',
        },
        {
          title: 'Agree to receive transactional SMS messages',
        },
        {
          title: 'Notification sounds',
          description: 'Play a sound when new messages arrive in threads',
        },
        {
          title: 'Notification types',
        },
        {
          title: 'Remind me before due date',
        },
      ],
      skills: [
        {
          title: 'My skills',
          description:
            'Manage your skills and expertise. Admins can verify skills and set billable rates.',
        },
        {
          title: 'Skill',
        },
        {
          title: 'Proficiency level:',
        },
        {
          title: 'Notes',
        },
        {
          title: 'Years of experience',
        },
        {
          title: 'Certified',
          description: 'Do you have an official certification?',
        },
      ],
    },
  },
}
